export const segmentation = {
  CUSTOMERS_INTERACTIONS: 'v2/analytics/customers/interactions',
  CUSTOMER_PROBABILITY: 'v2/analytics/customers/{id}/interactions',
};
